import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CorretorService } from '../../services/corretor.service';
import { CorretorResposneDto } from '../../dto/corretor-response.dto';

@Component({
   selector: 'app-corretores-gallery',
   standalone: true,
   imports: [CommonModule, MatDialogModule, MatIcon, MatButton],
   templateUrl: './corretores-gallery.component.html',
   styleUrl: './corretores-gallery.component.scss'
})
export class CorretoresGalleryComponent {
   @Input() mobile: boolean = true;
   // 🔹 Unidades e Corretores
   corretores: CorretorResposneDto[] = [];
   groupedCorretores: any[] = [];

   constructor(public router: Router, public corretorService: CorretorService) { }

   async ngOnInit() {
      try {
         this.corretores = await this.corretorService.getCorretores();
         this.groupCorretores();

      } catch (e) {
         console.error(e);
      }
   }

   groupCorretores() {
      var itemsPerSlide = 5;
      if (this.mobile) {
         itemsPerSlide = this.corretores.length; // Em mobile, exibir 1 por slide
      }
      this.groupedCorretores = [];

      for (let i = 0; i < this.corretores.length; i += itemsPerSlide) {
         this.groupedCorretores.push(this.corretores.slice(i, i + itemsPerSlide));
      }
   }

   acessaCorretor(id: number): void {
      this.router.navigate(['/corretor/', id.toString()], {
         queryParams: {
            contrato: 'Compra',
            sortby: 'd_date'
         }
      });
   }

   formatarWhatsapplink(telefone: string): string {
      const link = `https://wa.me/+55${telefone.replace(/\D/g, '')}`;
      return link;
   }
}


